// Set a value into the attribute of a specified element
// a single DOM Element
// White list other style attributes that you want to support
const setAttribute = function (elem, name, val, cllbck) {
  if (!elem || !name) return;
  switch (name) {
    case "backgroundImage":
      elem.style.backgroundImage = "url('" + val + "')";
      break;
    default:
      elem.setAttribute(name, val);
  }
  if (cllbck) cllbck(elem);
}